import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchSupportForwardCandidates = async (conversationId) => {
  const token = localStorage.getItem("token");
  const { data } = await axios.get(
    `${__API_URL__}/api/support/admin/conversations/${conversationId}/eligible-users/`,
    { headers: { Authorization: `Token ${token}` } }
  );
  return data;
};

const useGetSupportForwardCandidates = ({ conversationId, enabled = true }) => {
  return useQuery({
    queryKey: ["support_forward_candidates", conversationId],
    queryFn: () => fetchSupportForwardCandidates(conversationId),
    enabled: enabled && Boolean(conversationId),
  });
};

export default useGetSupportForwardCandidates;
